import request from '@/utils/request'


// 燃气总览信息
export function getGasOverview(data) {
  return request({
    url: '/NongChunRanQi/ShuJuZhongLan',
    method: 'post',
    params: data
  })
}

// 燃气运行分布
export function getGasRunDistribution(data) {
  return request({
    url: '/NongChunRanQi/YinHuanFenBu',
    method: 'post',
    params: data
  })
}

// 各村组数据
export function getCunZuYiChang(data) {
  return request({
    url: '/NongChunRanQi/ChunZuYiChang',
    method: 'post',
    params: data
  })
}

// 用户列表
export function getUserpageList(data) {
  return request({
    url: '/NongChunRanQi/UserpageList',
    method: 'post',
    params: data
  })
}

//获取燃气列表
export function getGasListFn(data) {
  return request({
    url: '/appNongChunRanQi/GetGasSupplier',
    method: 'post',
    params: data
  })
}


